export function getStatsByCategoryIdsAndPlayingAs(categoryIds, stats, filterPlayingAs, isHomeTeam, statIndexes) {
  const teamPlayingAs = filterPlayingAs === 2 ? [1, 2] : [isHomeTeam ? 1 : 2];
  return stats.filter(stat => {
    return categoryIds.includes(stat[statIndexes.categoryId]) && teamPlayingAs.includes(stat[statIndexes.playingAs]);
  });
}
